import * as React from "react";
import styled, { css } from "styled-components";
import Icon from "components/common/Icon";
import { getPrettifiedValue, convertValueToUnit } from "views/components/visualizations/utils/unitConverters";
import formatValueWithUnitLabel from "views/components/visualizations/utils/formatValueWithUnitLabel";
import getUnitTextLabel from "views/components/visualizations/utils/getUnitTextLabel";
import { formatTrend } from "util/NumberFormatting";
import { diff } from "./trendDirection";
const TextContainer = styled.div(
  ({ theme }) => css`
    margin-bottom: ${theme.spacings.xxs};
    text-align: right;
    font-family: ${theme.fonts.family.body};
  `
);
const _trendIcon = (delta) => (
  // eslint-disable-next-line no-nested-ternary
  delta === 0 ? "arrow_circle_right" : delta > 0 ? "arrow_circle_up" : "arrow_circle_down"
);
const getTrendConvertedValues = (current, previous, fieldUNit) => {
  const [difference, differencePercent] = diff(current, previous);
  if (!(fieldUNit == null ? void 0 : fieldUNit.isDefined)) {
    return {
      previousConverted: previous,
      differenceConverted: difference,
      differencePercent,
      unitAbbrevString: ""
    };
  }
  const originalParams = { unitType: fieldUNit == null ? void 0 : fieldUNit.unitType, abbrev: fieldUNit == null ? void 0 : fieldUNit.abbrev };
  const { unit: currentPrettyUnit } = getPrettifiedValue(current, originalParams);
  const currentPrettyParams = { unitType: currentPrettyUnit == null ? void 0 : currentPrettyUnit.unitType, abbrev: currentPrettyUnit == null ? void 0 : currentPrettyUnit.abbrev };
  const { value: prettyDiff } = convertValueToUnit(difference, originalParams, currentPrettyParams);
  const { value: previousPretty } = convertValueToUnit(previous, originalParams, currentPrettyParams);
  return {
    previousConverted: `${formatValueWithUnitLabel(previousPretty, currentPrettyUnit.abbrev)} (${previous})`,
    unitAbbrevString: ` ${getUnitTextLabel(currentPrettyUnit.abbrev)}`,
    differenceConverted: prettyDiff,
    differencePercent
  };
};
const Trend = ({ current, previous, unit = void 0 }, ref) => {
  const { differenceConverted, differencePercent, unitAbbrevString, previousConverted } = getTrendConvertedValues(
    current,
    previous,
    unit
  );
  const trendIcon = _trendIcon(differenceConverted);
  const absoluteDifference = Number.isFinite(differenceConverted) ? `${formatTrend(differenceConverted)}${unitAbbrevString}` : "--";
  const relativeDifference = Number.isFinite(differencePercent) ? formatTrend(differencePercent, { percentage: true }) : "--";
  return /* @__PURE__ */ React.createElement(TextContainer, { ref }, /* @__PURE__ */ React.createElement(Icon, { name: trendIcon, "data-testid": "trend-icon" }), " ", /* @__PURE__ */ React.createElement(
    "span",
    {
      "data-testid": "trend-value",
      "aria-label": `Trend: ${absoluteDifference} (${relativeDifference}) compared to previous value of ${previousConverted}`,
      title: `Previous value: ${previousConverted}`
    },
    absoluteDifference,
    " / ",
    relativeDifference
  ));
};
Trend.displayName = "Trend";
export default React.forwardRef(Trend);
